<div class="w-100" *ngIf="options?.showAutocomplete; else cards">
  <mat-form-field appearance="outline">
    <mat-label>
      Tipo de vehiculo
      <span class="asterisk" *ngIf="utils.isRequiredField(vehicleCtrl)">*</span>
      <span class="optional" *ngIf="!utils.isRequiredField(vehicleCtrl)">(opcional)</span>
    </mat-label>
    <input (keyup)="changeValue()" type="text" matInput [matAutocomplete]="auto" [formControl]="vehicleCtrl">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayVehicleType"
      (optionSelected)="onSelectValue($event)">
      <mat-option *ngFor="let type of vehicleTypes" [value]="type">
        <span>{{type.name}}</span>
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="vehicleCtrl.errors?.required">
      {{ utils.giveMessageError('MANDATORY_FIELD') }}
    </mat-error>
  </mat-form-field>
</div>

<ng-template #cards>
  <div class="container">
    <div id="mainFreightCharacteristics" class="col-md-12 mb-md-0 mb-12 container">
      <div class="row">
        <div class="col-md-12 mb-md-0 mb-12">
          <label class="title">
            Selecciona el tipo de vehículo
          </label>
        </div>
        <mat-form-field appearance="outline" class="col-lg-6 px-0">
          <mat-label>Vehículo</mat-label>
          <mat-select [formControl]="vehicleCtrl" (selectionChange)="onSelectVehicleType($event)">
            <mat-option *ngFor="let vehicle of vehicleTypesAndAliases" [value]="vehicle">
              {{vehicle.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="col-12 d-flex flex-wrap p-0 cards-grid" *ngIf="vehiclesSelected.length">
          <div class="vehicle-card col-lg-6" *ngFor="let vehicle of vehiclesSelected.controls; let i = index">
            <button type="button" class="remove-card-btn" mat-icon-button matTooltip="Eliminar vehículo"
              (click)="removeSelectedVehicle(i)">
              <i class="fas fa-times"></i>
            </button>
            <div class="vehicle-card__header">
              <div class="vehicle-card__icon">
                <img [src]="getNameIconVehicle(vehicle.get('vehicle')?.value)" (error)="onErrorRenderImage($event)"
                  alt="">
              </div>
              <div class="vehicle-card__title">
                {{ vehicle.get('vehicleAlias')?.value ? vehicle.get('vehicleAlias')?.value :
                vehicle.get('vehicle')?.value }}
              </div>
            </div>
            <div class="vehicle-card__axles">
              <label *ngIf="isAliasSelected(i) || !showAxlesControl(vehicle.get('vehicle')?.value); else editableAxles">
                <span class="text-bold">N° de ejes:</span> {{ vehicle.get('vehicleAxles')?.value }}
              </label>
              <ng-template #editableAxles>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>N° de ejes</mat-label>
                  <input type="number" min="2" matInput [formControl]="vehicle.get('vehicleAxles')"
                    (change)="onChangeVehicleAxles($event, i)">
                  <mat-error *ngIf="vehicle.get('vehicleAxles')?.errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                  </mat-error>
                  <mat-error *ngIf="vehicle.get('vehicleAxles')?.errors?.min">
                    {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED_SHORT', 'N° de ejes', minAxles) }}
                  </mat-error>
                </mat-form-field>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="col-md-12 mb-md-0 mb-12">
          <div class="row">
            <div class="button-container justify-content-center mt-3 w-100">
              <button mat-raised-button class="secondary-sharp mr-4" (click)="stepBack()">Atrás</button>
              <button mat-raised-button class="bg-color-primary" (click)="nextStep()">Siguiente</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>